import i18n from '../i18n';

/**
 * Resolve display label for API enum/status values.
 * Falls back to API-provided status_label or raw value.
 */
export function getStatusLabel(value, category, apiLabel) {
  if (apiLabel && apiLabel !== value) {
    return apiLabel;
  }

  if (!value) {
    return '';
  }

  const key = `statuses:${category}.${value}`;
  if (i18n.exists(key)) {
    return i18n.t(key);
  }

  if (category === 'support_priority' || category === 'priority') {
    const priorityKey = `statuses:support_priority.${value}`;
    if (i18n.exists(priorityKey)) {
      return i18n.t(priorityKey);
    }
  }

  return value;
}

export function getSubscriptionStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'subscription', apiLabel);
}

export function getInvoiceStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'invoice', apiLabel);
}

export function getPaymentStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'payment', apiLabel);
}

export function getSupportStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'support', apiLabel);
}

export function getSupportPriorityLabel(priority, apiLabel) {
  return getStatusLabel(priority, 'support_priority', apiLabel);
}

export function getTenantAccessStatusLabel(code, apiLabel) {
  return getStatusLabel(code, 'tenant_access', apiLabel);
}

export function getOnboardingIntentStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'onboarding_intent', apiLabel);
}

export function getPlanStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'plan', apiLabel);
}

export function getProviderLabel(provider, apiLabel) {
  return getStatusLabel(provider, 'provider', apiLabel);
}

export function getSetupSessionStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'setup_session', apiLabel);
}

export function getSetupStepStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'setup_step', apiLabel);
}

export function getProvisioningRunStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'provisioning_run', apiLabel);
}

export function getProvisioningStepStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'provisioning_step', apiLabel);
}

export function getHealthCheckStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'health_check', apiLabel);
}

export function getProvisioningStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'provisioning_status', apiLabel);
}

export function getSchemaVersionStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'schema_version', apiLabel);
}

export function getSchemaPlanStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'schema_plan', apiLabel);
}

export function getSchemaRiskLabel(status, apiLabel) {
  return getStatusLabel(status, 'schema_risk', apiLabel);
}

export function getTenantStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'tenant', apiLabel);
}

export function getBillingReadinessLabel(status, apiLabel) {
  return getStatusLabel(status, 'billing_readiness', apiLabel);
}

export function getMembershipStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'membership', apiLabel);
}

export function getInvitationStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'invitation', apiLabel);
}

export function getCustomerStatusLabel(status, apiLabel) {
  return getStatusLabel(status, 'customer', apiLabel);
}
